import { memo } from 'react';

const ViewTypeShadow = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_8653_18666" fill="white">
        <path
          d="M30 10L30 26C30 27.1046 29.1046 28 28 28L5.99999 28C4.89542 28 3.99999 27.1046 3.99999 26L15 26L26 26C27.1046 26 28 25.1046 28 24L28 8C29.1046 8 30 8.89543 30 10Z"/>
      </mask>
      <path
        d="M30 10L30 26C30 27.1046 29.1046 28 28 28L5.99999 28C4.89542 28 3.99999 27.1046 3.99999 26L15 26L26 26C27.1046 26 28 25.1046 28 24L28 8C29.1046 8 30 8.89543 30 10Z"
        fill="#909090"/>
      <path
        d="M3.99999 26L2.49999 26L2.49999 24.5L3.99999 24.5L3.99999 26ZM5.99999 28L5.99999 29.5L5.99999 28ZM28 8L26.5 8L26.5 6.5L28 6.5L28 8ZM28 28L28 26.5L28 28ZM26 26L26 27.5L26 26ZM15 26L15 27.5L15 26ZM28.5 26L28.5 10L31.5 10L31.5 26L28.5 26ZM5.99999 26.5L28 26.5L28 29.5L5.99999 29.5L5.99999 26.5ZM5.49999 26C5.49999 26.2761 5.72385 26.5 5.99999 26.5L5.99999 29.5C4.067 29.5 2.49999 27.933 2.49999 26L5.49999 26ZM28.5 10C28.5 9.72386 28.2761 9.5 28 9.5L28 6.5C29.933 6.5 31.5 8.067 31.5 10L28.5 10ZM31.5 26C31.5 27.933 29.933 29.5 28 29.5L28 26.5C28.2761 26.5 28.5 26.2761 28.5 26L31.5 26ZM26.5 24L26.5 8L29.5 8L29.5 24L26.5 24ZM29.5 24C29.5 25.933 27.933 27.5 26 27.5L26 24.5C26.2761 24.5 26.5 24.2761 26.5 24L29.5 24ZM3.99999 24.5L15 24.5L15 27.5L3.99999 27.5L3.99999 24.5ZM15 24.5L26 24.5L26 27.5L15 27.5L15 24.5Z"
        fill="#909090" mask="url(#path-1-inside-1_8653_18666)"/>
      <path
        d="M26 25.25C26.6904 25.25 27.25 24.6904 27.25 24L27.25 8C27.25 7.30965 26.6904 6.75 26 6.75L4 6.75C3.30965 6.75 2.75 7.30964 2.75 8L2.75 24C2.75 24.6904 3.30964 25.25 4 25.25L26 25.25Z"
        stroke="#909090" strokeWidth="1.5"/>
    </svg>

  );
}

export default memo(ViewTypeShadow);
import { memo } from 'react';

const ViewTypeShadow = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_8653_18666" fill="white">
        <path
          d="M30 10L30 26C30 27.1046 29.1046 28 28 28L5.99999 28C4.89542 28 3.99999 27.1046 3.99999 26L15 26L26 26C27.1046 26 28 25.1046 28 24L28 8C29.1046 8 30 8.89543 30 10Z"/>
      </mask>
      <path
        d="M30 10L30 26C30 27.1046 29.1046 28 28 28L5.99999 28C4.89542 28 3.99999 27.1046 3.99999 26L15 26L26 26C27.1046 26 28 25.1046 28 24L28 8C29.1046 8 30 8.89543 30 10Z"
        fill="#909090"/>
      <path
        d="M3.99999 26L2.49999 26L2.49999 24.5L3.99999 24.5L3.99999 26ZM5.99999 28L5.99999 29.5L5.99999 28ZM28 8L26.5 8L26.5 6.5L28 6.5L28 8ZM28 28L28 26.5L28 28ZM26 26L26 27.5L26 26ZM15 26L15 27.5L15 26ZM28.5 26L28.5 10L31.5 10L31.5 26L28.5 26ZM5.99999 26.5L28 26.5L28 29.5L5.99999 29.5L5.99999 26.5ZM5.49999 26C5.49999 26.2761 5.72385 26.5 5.99999 26.5L5.99999 29.5C4.067 29.5 2.49999 27.933 2.49999 26L5.49999 26ZM28.5 10C28.5 9.72386 28.2761 9.5 28 9.5L28 6.5C29.933 6.5 31.5 8.067 31.5 10L28.5 10ZM31.5 26C31.5 27.933 29.933 29.5 28 29.5L28 26.5C28.2761 26.5 28.5 26.2761 28.5 26L31.5 26ZM26.5 24L26.5 8L29.5 8L29.5 24L26.5 24ZM29.5 24C29.5 25.933 27.933 27.5 26 27.5L26 24.5C26.2761 24.5 26.5 24.2761 26.5 24L29.5 24ZM3.99999 24.5L15 24.5L15 27.5L3.99999 27.5L3.99999 24.5ZM15 24.5L26 24.5L26 27.5L15 27.5L15 24.5Z"
        fill="#909090" mask="url(#path-1-inside-1_8653_18666)"/>
      <path
        d="M26 25.25C26.6904 25.25 27.25 24.6904 27.25 24L27.25 8C27.25 7.30965 26.6904 6.75 26 6.75L4 6.75C3.30965 6.75 2.75 7.30964 2.75 8L2.75 24C2.75 24.6904 3.30964 25.25 4 25.25L26 25.25Z"
        stroke="#909090" strokeWidth="1.5"/>
    </svg>

  );
}

export default memo(ViewTypeShadow);
